import React from 'react'
import { ButtonModifiers, ButtonProps, ButtonVariant } from './'
import './style.module.scss'

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      type = 'button',
      disabled,
      variant,
      className,
      isLoading,
      modifiers,
      children,
      onClick,
      testId,
      ...buttonProps
    }: ButtonProps,
    ref
  ): JSX.Element => {
    const buttonClassNames: string[] = ['Button']
    switch (variant) {
      case ButtonVariant.LINK:
        buttonClassNames.pop()
        buttonClassNames.push('Link')
        break
      case ButtonVariant.SECONDARY:
        buttonClassNames.push('Button--secondary')
        buttonClassNames.push('Button--secondary--action-blue')
        break
      case ButtonVariant.TERTIARY:
        buttonClassNames.push('Button--tertiary')
        break
      case ButtonVariant.DELETE:
        buttonClassNames.push('Button--delete')
        break
      case ButtonVariant.PRIMARY:
      default:
        buttonClassNames.push('Button--primary')
        break
    }

    if (modifiers?.includes(ButtonModifiers.BLOCK)) {
      buttonClassNames.push('Button--block')
    }

    if (modifiers?.includes(ButtonModifiers.SMALL)) {
      buttonClassNames.push('Button--small')
    }

    if (modifiers?.includes(ButtonModifiers.REVERSED)) {
      buttonClassNames.push('Button--reversed')
    }

    if (className) {
      buttonClassNames.push(className)
    }

    return (
      <button
        type={type}
        {...buttonProps}
        onClick={onClick}
        ref={ref}
        disabled={disabled}
        className={buttonClassNames.join(' ')}
        data-testid={testId ? testId : null}
      >
        {children}
        {isLoading && (
          <div className="u-marginLeft8 Loading Loading--small">
            <div className="Loading-indicator" />
            <div className="Loading-indicator" />
            <div className="Loading-indicator" />
          </div>
        )}
      </button>
    )
  }
)
